import styled from 'styled-components'

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
`
